import { CustomTooltip, BuiltInTooltip } from '../../tooltip/types';

const mapChartType = (inpType) => {
    if (!inpType) return 'spline';
    switch (inpType) {
        case 'line':
            return 'spline';
        case 'area':
            return 'areaspline';
        default:
            return inpType;
    }
};

export const getCustomChartDef = (testType) => {
    let units = '';
    let multiplier = 0;
    const thresholds = [];
    const thresholdMetricMap = {};
    const { thresholdInfo } = testType;
    if (thresholdInfo) {
        thresholdInfo.forEach((info) => {
            thresholdMetricMap[info.metric] = {
                excessive: info.excessive,
                degraded: info.degraded,
                inverted: info.inverted,
            };
            thresholds.push({
                hidden: true,
                threshold: 'degraded',
                key: info.degraded,
                label: 'Degraded',
                color: 'yellow',
                units: info.units,
                multiplier: info.multiplier,
            });
            thresholds.push({
                hidden: true,
                threshold: 'excessive',
                key: info.excessive,
                label: 'Excessive',
                color: 'orange',
                units,
                multiplier,
            });
        });
    }

    const inpChartType = testType?.chartConfig?.chart?.type;
    const defChartType = mapChartType(inpChartType);
    let chartThreshold;
    const chartMetrics = testType.metrics
        .filter((metric) => !metric.hidden)
        .filter((metric) => !metric.string)
        .map((metric) => {
            units = metric.units;
            multiplier = metric.multiplier;
            const thresholdMetric = thresholdMetricMap[metric.name];
            if (thresholdMetric) chartThreshold = true;
            const chartType = metric.chartSeriesOverrides?.type
                ? mapChartType(metric.chartSeriesOverrides.type)
                : defChartType;
            return {
                key: `avg${metric.name}`,
                chartType,
                name: metric.name,
                index: metric.chartSeriesOverrides?.yAxis,
                label: metric.title,
                color: metric.color,
                units: metric.units,
                multiplier: metric.multiplier,
                degraded: thresholdMetric?.degraded,
                excessive: thresholdMetric?.excessive,
                inverted: thresholdMetric?.inverted,
                forceDecimals: true,
            };
        });

    const yAxis = testType?.chartConfig?.yAxis;
    const tooltip = chartThreshold ? CustomTooltip : BuiltInTooltip;
    const stacking = testType?.chartConfig?.plotOptions?.series?.stacking;
    return {
        tooltip,
        stacking,
        statusMetric: 'status',
        yAxis,
        thresholds,
        thresholdMetricMap,
        chartTrends: chartMetrics.concat(thresholds),
    };
};
